module.exports = __webpack_public_path__ + "src/assets/img/rain.98da10f4.svg";